import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=6538dfb9&scoped=true&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=6538dfb9&prod&scoped=true&lang=css&"
import style1 from "./Ranking.vue?vue&type=style&index=1&id=6538dfb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538dfb9",
  null
  
)

export default component.exports